import React from 'react';
import InsuranceQuoteSelect from '../../InsuranceQuoteSelect';

// Homepage closing customer-reviews CTA band (STATIC, code-managed). Brand-blue
// band with curated 5-star Google reviews (verbatim) plus the Select-Insurance
// quote picker. Refresh the REVIEWS list and the rating/count snapshot periodically.
const REVIEWS = [
    { name: "Amber Huggins", text: "We had a great experience with GM! Hovanes was very gracious with his time in giving us our initial quote, and Hayk was able to get us all signed up and squared away over the phone. It was an easy, direct process with friendly service. Thank you!" },
    { name: "Feross Alkhader", text: "One of the few insurance companies that felt reliable. They didn't put me on hold or transfer me to another representative, they actually helped me choose the right coverage for my commercial auto. I would highly recommend starting your quotes." },
    { name: "Aram M.", text: "Great customer service. Called for a quote and didn't even have to come in. Finalized everything through phone/text/email." },
    { name: "Regina Basnett", text: "Very knowledgeable and great customer service. Had our policy done within 24 hours." },
    { name: "Shannon K.", text: "I've been dealing with GM Insurance Services for around 15 years now and they make everything really easy." },
    { name: "Gayane M.", text: "Getting a insurance quote was very informative and straight forward. Staff is friendly." },
];

function HomeF7() {
    return (
        <div className="reviews-cta">
            <style>{`
                .reviews-cta{width:100vw;margin-left:-15px;background:#006AB0;color:#fff;text-align:center;padding:60px 24px;}
                .reviews-cta__inner{max-width:1080px;margin:0 auto;}
                .reviews-cta h2{color:#fff;font-size:2em;font-weight:700;margin-bottom:.5em;}
                .reviews-cta__rating{color:#fff;font-size:1.05rem;margin:0 0 .3em;}
                .reviews-cta__stars{color:#FFC533;letter-spacing:3px;font-size:1.3rem;}
                .reviews-cta__count{color:#cfe6f7;font-size:.92rem;margin:0 0 2em;}
                .reviews-cta__cards{display:grid;grid-template-columns:repeat(3,1fr);gap:18px;margin-bottom:2.4em;text-align:left;}
                @media(max-width:900px){.reviews-cta__cards{grid-template-columns:repeat(2,1fr);}}
                @media(max-width:600px){.reviews-cta__cards{grid-template-columns:1fr;}}
                .review-card{background:#fff;border-radius:var(--border-radius-lg,12px);padding:22px 20px;display:flex;flex-direction:column;gap:10px;}
                .review-card .rc-stars{color:#FFC533;letter-spacing:2px;font-size:1rem;}
                .review-card p{color:#42526b;font-size:.92rem;line-height:1.6;margin:0;flex:1;}
                .review-card .rc-name{color:#132042;font-weight:600;font-size:.9rem;margin:0;}
                .reviews-cta__quote{max-width:600px;margin:0 auto;}
            `}</style>
            <div className="reviews-cta__inner">
                <h2>See What Customers Say About GM Insurance Services</h2>
                <div className="reviews-cta__rating">
                    <span className="reviews-cta__stars">★★★★★</span> 4.8
                </div>
                <p className="reviews-cta__count">171 Google reviews</p>

                <div className="reviews-cta__cards">
                    {REVIEWS.map(({ name, text }) => (
                        <div className="review-card" key={name}>
                            <div className="rc-stars">★★★★★</div>
                            <p>"{text}"</p>
                            <p className="rc-name">{name}</p>
                        </div>
                    ))}
                </div>

                <div className="reviews-cta__quote">
                    <InsuranceQuoteSelect placeholder="Select Insurance" buttonText="Get a Free Quote" />
                </div>
            </div>
        </div>
    );
}

export default HomeF7;
